import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
} from '@angular/router';

import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class NephroGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate() {
        return (
            this.authService.isAdmin ||
            this.authService.canEditAdministrativeInfos.nephro ||
            this.authService.canEditMedicalInfos.nephro
        );
    }
}
